import type { MouseEventHandler } from 'react';

import React from 'react';

import type { ListItemProps } from '../../List';

import { useMenuContext } from '../Menu';
import { ListItem } from '../../List';

export type MenuItemProps = ListItemProps;

/**
 * Same as ListItemButton, just allows manipulation of dropdown through context
 */
const MenuItem = (props: MenuItemProps) => {
  const { multiple, setOpen } = useMenuContext();

  const handleClick: MouseEventHandler<HTMLLIElement> = React.useCallback(
    (e) => {
      if (props.onClick) props.onClick(e);
      if (!multiple) setOpen((state) => !state);
    },
    [props, multiple, setOpen],
  );

  return <ListItem {...props} onClick={handleClick} />;
};

export default MenuItem;
